import { type Enum } from '../../../../../react-commons/types/enum';
import { getEnumFormatter } from './getEnumFormatter';

export const formatEnum = <E extends string>(type: Enum<E>, value: E | null | undefined): string => {
    if (!value) {
        return '';
    }
    const formatter = getEnumFormatter(type);
    return formatter(value);
};
